var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-marker',{attrs:{"position":_vm.position,"label":{
      text: _vm.sequenceNumber.toString(),
      color: 'white',
      fontSize: '16px'
    },"icon":_vm.markerIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }